import React, { useState } from "react";
import type { AuthController } from "../state/authStore";

type Props = {
  auth: AuthController;
};

export default function SignInPage(props: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [totpCode, setTotpCode] = useState("");
  const [recoveryCode, setRecoveryCode] = useState("");
  const { auth } = props;

  return (
    <div className="authPage">
      <form
        className="authCard"
        onSubmit={(e) => {
          e.preventDefault();
          void auth.signInPassword(username, password);
        }}
      >
        <h1>Divina</h1>
        <p className="muted">Monitoring and the honest record. Sign in to continue.</p>

        <label className="field">
          <span className="fieldLabel">Username</span>
          <input
            autoComplete="username"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="username"
          />
        </label>

        <label className="field">
          <span className="fieldLabel">Password</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
          />
        </label>

        {auth.stepUpRequested ? (
          <div className="authStepUp">
            <div className="muted">Step-up required. Complete the MFA challenge to sign in.</div>
            <div className="authStepUpRow">
              <label className="field">
                <span className="fieldLabel">TOTP code</span>
                <input value={totpCode} onChange={(e) => setTotpCode(e.target.value)} placeholder="123456" />
              </label>
              <button
                type="button"
                className="btn secondary"
                disabled={!auth.authMethods.totp || auth.mfaSubmitting}
                onClick={() => void auth.verifyTotp(totpCode)}
              >
                Verify TOTP
              </button>
            </div>
            <div className="authStepUpRow">
              <label className="field">
                <span className="fieldLabel">Recovery code</span>
                <input value={recoveryCode} onChange={(e) => setRecoveryCode(e.target.value)} placeholder="XXXX-XXXX" />
              </label>
              <button
                type="button"
                className="btn secondary"
                disabled={!auth.authMethods.recovery || auth.mfaSubmitting}
                onClick={() => void auth.verifyRecovery(recoveryCode)}
              >
                Use recovery code
              </button>
            </div>
          </div>
        ) : null}

        {auth.authError ? <div className="banner" aria-live="polite">{auth.authError}</div> : null}

        <button className="btn" type="submit" disabled={auth.authSubmitting || auth.passkeySubmitting}>
          {auth.authSubmitting ? "Signing in…" : "Sign In"}
        </button>
        <button
          className="btn secondary"
          type="button"
          disabled={auth.authSubmitting || auth.passkeySubmitting}
          onClick={() => void auth.signInPasskey(username)}
        >
          {auth.passkeySubmitting ? "Waiting for passkey…" : "Sign In with Passkey"}
        </button>
      </form>
    </div>
  );
}
